import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";

import Logo from '../assets/images/logo/logo-header.png';

const Footer = () => {
  return (
    <>
      <div className="footer">
        <Container>
          <Row>
            <Col md="12" className="d-flex justify-content-between align-items-center">
              <span>Copyright &copy; 2021 by Nitijana</span>
              <Link to="/">
                <img src={Logo} alt="" />
              </Link>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Footer